import gql from "graphql-tag";

const mentorListQuery = gql`
    query MentorListQuery(
        $universitySlug: String
        $degreeId: String
        $mentorId: String
        $countryId: String
        $level: String
        $isDegreeTypesEnabled: Boolean = false
    ) {
        mentorList(
            universitySlug: $universitySlug
            degreeId: $degreeId
            mentorId: $mentorId
            countryId: $countryId
            level: $level
        ) {
            mentors {
                id
                firstName
                profilePhoto(raw: true)
                lastSeen
                degree @skip(if: $isDegreeTypesEnabled) {
                    id
                    name
                }
                degrees @include(if: $isDegreeTypesEnabled) {
                    degreeType
                    degree {
                        id
                        name
                    }
                }
                placeName
                country {
                    id
                    code
                    name
                }
                mentorFields {
                    primaryFlag {
                        code
                    }
                    secondaryFlag {
                        code
                    }
                }
                languages {
                    id
                    name
                }
                year
                favouriteModules {
                    id
                    name
                }
                pastQualification
                interests {
                    id
                    name
                }
                societies {
                    id
                    name
                }
                shortBio
                degreeLevel
                customAttributes(active: true) {
                    value
                    attribute {
                        id
                        name
                    }
                    ... on SingleChoiceValueField {
                        option {
                            id
                            value
                        }
                    }
                }
            }
            degrees {
                id
                name
            }
            countries {
                id
                name
            }
            levels
        }
    }
`;

export default mentorListQuery;
